import React from 'react'
import ReactDOM from 'react-dom/client'
import { IS_MOCK } from '~/config/mode'
import { installMockServer } from '~/mock/server'
import { installShowcaseSamples } from '~/showcase/samples'
import { initializeApiInterceptor } from '@/services/apiInterceptor'
import { AuthProvider } from '@/features/auth'
import { useReloadOnNewBuild } from '@/hooks/useReloadOnNewBuild'
import App from './App'
import './index.css'

// Order matters: the demo server sits under the token-refresh interceptor, exactly where the network would be.
if (IS_MOCK) installMockServer()
// TEMPORARY showcase samples (test links only; production builds it off) - src/showcase/samples.ts
if (import.meta.env.VITE_SHOWCASE_SAMPLES === '1') installShowcaseSamples()
// Today's windows that open in a portal (straight on <body>: tip, purchase, ...) get the same scoped reset + new look
new MutationObserver(() => {
  for (const el of Array.from(document.body.children)) if (el.tagName === 'DIV' && el.id !== 'root' && !el.classList.contains('tw-scope')) el.classList.add('tw-scope', 'v2-portal')
}).observe(document.body, { childList: true })
initializeApiInterceptor()

function BuildWatcher() {
  useReloadOnNewBuild()
  return null
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BuildWatcher />
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
)
